// @flow

import React from 'react';
import styled from 'styled-components';
import ListContainer from '../../list';
import type { FAQItemInCategory } from '../../../types/faq';
import type { Theme } from '../../../types';

type Props = {|
  results: Array<FAQItemInCategory>,
  noResultsHeader: string,
  resultsHeader: string,
|};

const Header = styled<any, Theme>('span')`
  font-size: 1rem;
`;

const StyledList = styled<typeof ListContainer, Theme>(ListContainer)`
  margin-top: 1rem;
`;

const SearchResults = ({
  results,
  noResultsHeader,
  resultsHeader,
}: Props) => (
  <section>
    <Header
      dangerouslySetInnerHTML={{ __html: results.length === 0 ? noResultsHeader : resultsHeader }}
    />
    <StyledList
      listStyle="bullets"
      items={results.map(result => ({
        usp: result.post_title,
        url: result.permalink,
      }))}
    />
  </section>
);

export default SearchResults;
